import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { getCurrentSongId } from "@/lib/studioMode";

/** /create/export → the current song's Export sheet (or My Projects when there is no song yet). */
export default function ExportRoute() {
  const navigate = useNavigate();
  useEffect(() => {
    const id = getCurrentSongId();
    if (id) navigate(`/create/song/${id}?export=1`, { replace: true });
    else {
      toast.message("Pick a song to export", { description: "Open one of your projects, then press Export Song." });
      navigate("/create/projects", { replace: true });
    }
  }, [navigate]);
  return null;
}
